import React from "react";
import { Check, Lock, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";

// A single streak-milestone chip in the Dashboard's horizontal milestones
// row. States: locked (not reached), ready (reached, claimable), claimed.
// Condensed for phone.
export default function MilestoneChip({ m, onClaim }) {
  const { t } = useTranslation();
  const state = m.claimed ? "claimed" : m.reached ? "ready" : "locked";
  return (
    <div
      data-testid={`milestone-${m.day}`}
      className={`flex-shrink-0 w-[72px] p-2 rounded-xl border text-center ${
        state === "ready"
          ? "bg-[#5F7161] text-white border-[#5F7161]"
          : state === "claimed"
          ? "bg-[#F1EEE6] text-[#6E756B] border-[#E6E2D8]"
          : "bg-white text-[#2C332A] border-[#E6E2D8]"
      }`}
    >
      <div className="flex items-center justify-center mb-0.5">
        {state === "claimed" ? <Check size={14} /> : state === "locked" ? <Lock size={12} strokeWidth={1.5} /> : <Sparkles size={14} strokeWidth={1.5} />}
      </div>
      <p style={{ fontFamily: "Outfit, sans-serif" }} className="text-sm font-semibold leading-none">
        {t("daily_goal.day_n", { n: m.day })}
      </p>
      <p className="text-[9px] mt-0.5 opacity-80">{t("journey.coins_reward", { n: m.reward_coins })}</p>
      {state === "ready" && (
        <Button
          data-testid={`claim-milestone-${m.day}`}
          size="sm"
          onClick={() => onClaim(m.day)}
          className="mt-1.5 w-full h-7 rounded-full bg-white text-[#5F7161] hover:bg-white/90 text-[11px] px-1"
        >
          {t("daily_goal.claim_short")}
        </Button>
      )}
    </div>
  );
}
